import GuestLayoutCompact from '@/Layouts/Guest/GuestLayoutCompact';
import InputError from '@/Components/InputError';
import InputLabel from '@/Components/InputLabel';
import PrimaryButton from '@/Components/PrimaryButton';
import TextInput from '@/Components/TextInput';
import {Head, useForm} from '@inertiajs/react';
import {FormEventHandler} from 'react';
import useTranslations from '@/hooks/useTranslations';

export default function ForgotPassword({status}: { status?: string }) {
    const { __ } = useTranslations();
    const {data, setData, post, processing, errors} = useForm({
        email: '',
    });

    const submit: FormEventHandler = (e) => {
        e.preventDefault();

        post(route('password.email'));
    };

    return (
        <GuestLayoutCompact>
            <Head title={__('password.request.title')}>
                <meta name="description" content={__('password.request.meta_description')}/>
            </Head>

            <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
                <h1 className="font-bold text-lg mb-4 mt-2 text-gray-900 dark:text-gray-100">{__('password.request.heading')}</h1>
                <p>
                    {__('password.request.description')}
                </p>
            </div>

            {status && <div className="mb-4 font-medium text-sm text-green-600">{status}</div>}

            <form onSubmit={submit}>
                <div>
                    <InputLabel htmlFor="email" value={__('password.request.email_label')}/>
                    <TextInput
                        id="email"
                        type="email"
                        name="email"
                        value={data.email}
                        className="mt-1 block w-full"
                        isFocused={true}
                        onChange={(e) => setData('email', e.target.value)}
                    />

                    <InputError message={errors.email} className="mt-2"/>
                </div>

                <div className="flex items-center justify-end mt-4">
                    <PrimaryButton className="w-full " disabled={processing}>
                        {__('password.request.submit')}
                    </PrimaryButton>
                </div>
            </form>
        </GuestLayoutCompact>
    );
}
